import axios from 'axios'

const api = axios.create({
  baseURL: 'http://localhost:8000/api/v1',  // 本地测试用绝对路径
  timeout: 15000
})

// 登录态：自动携带 token（Authorization: Bearer <token>）
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('api_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (res) => res.data,
  (err) => {
    // history 模式：401 统一回到登入专题页（登入门禁在页内完成，不跳后台）
    if (err.response?.status === 401 && !/\/(login|onboard)/.test(location.pathname)) {
      localStorage.removeItem('api_token')
      location.href = '/login'
    }
    // 提取可读错误信息：FastAPI 422 detail 可能是数组/对象，直接拼接会变 [object Object]
    let msg = ''
    const d = err.response?.data?.detail
    if (typeof d === 'string') msg = d
    else if (Array.isArray(d)) msg = d.map(x => x?.msg || '').filter(Boolean).join('；')
    else if (d && typeof d === 'object') msg = JSON.stringify(d)
    msg = msg || err.message || '请求失败'
    return Promise.reject(new Error(msg))
  }
)

export default api
